import { vehicleColorValues } from 'models/inventory/enums/vehicle.enum';
import { priceFormatFinancial } from 'models/shared/helpers/prices';
import { Provider } from 'models/provider/interfaces/provider.interface';
import { SkuVariant } from '../interfaces/sku-variant.interface';

export const variantLabel = (
	variant: SkuVariant,
	providers: Provider[],
): string => {
	const providerName = providers.find((p) => p._id === variant.provider)?.name;
	const parts = [
		variant.color ? `Color: ${vehicleColorValues[variant.color]}` : null,
		variant.hasGps ? 'Con GPS' : null,
		providerName ?? null,
	].filter(Boolean);

	const priceText = priceFormatFinancial(variant.price);
	return parts.length > 0
		? `${parts.join(' · ')} · ${priceText}`
		: `Estándar · ${priceText}`;
};
